//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import PurchaseOrderListView from '@/views/Purchase/PchPurchaseOrder/list'
import PurchaseOrderReceptionView from '@/views/Purchase/PchPurchaseOrder/reception'
import PurchaseOrderUpdateView from '@/views/Purchase/PchPurchaseOrder/update'

//
export default {
    path: 'purchase_orders',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'purchase-order-list',
            component: PurchaseOrderListView,
        },
        {
            path: ':id',
            name: 'purchase-order-update',
            component: PurchaseOrderUpdateView,
            meta: {
                title: 'Detalle de orden de compra',
            },
        },
        {
            path: 'reception/:id',
            name: 'purchase-order-reception',
            component: PurchaseOrderReceptionView,
            meta: {
                title: 'Recepción de orden de compra',
            },
        },
    ],
    meta: {
        title: 'Ordenes de compra',
    },
}
